<div
  id="header"
  class="navbar"
  role="navigation"
  fxLayout="row"
  fxLayoutAlign="space-between center"
>
  <h2 class="page-title">
    <mat-icon (click)="openMenu('1')" class="hamburger-menu">menu</mat-icon
    >&nbsp;&nbsp;
    @if (title == "AuditHub - Search" || title == "AuditHub - RegCompare") {
      <span
        class="clickable-breadcrumb"
        (click)="navigateToDashboard()"
        matTooltip="Go to Dashboard"
        matTooltipClass="tooltip2"
        >Dashboard</span
      >
      <span class="breadcrumb-separator"> > </span>
      <span class="current-page">{{
        title == "AuditHub - Search" ? "Audit Search" : "RegCompare"
      }}</span>
    } @else {
      {{ title }}
    }
    @if (
      title == "Product List" ||
      title == "New Template" ||
      title ==
        "Pocket
    Reference" ||
      title == "Custom Questions" ||
      title ==
        "Custom Ranking &
    Scoring"
    ) {
      <mat-icon class="help-info" (click)="openHelpInfo($event, title)"
        >info</mat-icon
      >
    }
  </h2>
  <ul class="header-profile">
    <div class="dropdown navbar-user">
      <a
        href="#"
        class="dropdown-toggle"
        data-bs-toggle="dropdown"
        role="button"
        aria-expanded="true"
      >
        {{ userEmail }}
        <span class="user-profile">
          <img src="/assets/images/User-icon.png" alt="" class=""
        /></span>
      </a>
      <ul class="dropdown-menu dropdown-menu-right">
        <!--a routerLink="/home" class="dropdown-item">Search</a>
          <a routerLink="/home" class="dropdown-item">Settings</a-->
        <li><div class="dropdown-divider"></div></li>
        <li>
          <a (click)="clearCache()" class="dropdown-item" href="#"
            >Clear Cache</a
          >
        </li>
        <li>
          <a (click)="aboutAudit($event)" class="dropdown-item"
            >About AuditHub</a
          >
        </li>
        <li>
          <a (click)="signOut()" class="dropdown-item" href="#">Sign Out</a>
        </li>
      </ul>
    </div>
  </ul>
</div>
